import { useEffect, useRef, useState } from 'react';

export const useMegaMenuItemHover = (onHover: () => void) => {
  const [isHovered, setIsHovered] = useState(false);
  const hoverTimer = useRef(null);

  const onHoverStarted = () => {
    hoverTimer.current = setTimeout(() => {
      setIsHovered(true);
      onHover();
    }, 200);
  };

  const onHoverEnded = () => {
    clearTimeout(hoverTimer.current);
    setIsHovered(false);
  };

  useEffect(() => {
    return () => {
      clearTimeout(hoverTimer.current);
    };
  }, []);

  return {
    isHovered,
    onMouseEnter: onHoverStarted,
    onMouseLeave: onHoverEnded,
  };
};
